import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({
    children,
    onNavigate,
    activePage,
    role = 'admin',
    userInfo = {},
    pageTitle = 'Dashboard',
    ...restProps
}) => {
    const resolvedUserInfo = restProps.accountsData || restProps.parentData || userInfo;
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);

    // Check if mobile on mount and resize
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 1024);
            if (window.innerWidth > 1024) {
                setIsSidebarOpen(false);
            }
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Reset hover states when sidebar closes
    useEffect(() => {
        if (!isSidebarOpen) {
            setHoveredItem(null);
        }
    }, [isSidebarOpen]);

    return (
        <div style={{
            margin: 0,
            padding: 0,
            boxSizing: 'border-box',
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            backgroundColor: '#f4f7fa',
            color: '#333',
            lineHeight: 1.6,
            minHeight: '100vh',
            width: '100%',
            overflowX: 'hidden'
        }}>
            {/* Global CSS Reset */}
            <style>
                {`
          *, *::before, *::after {
            box-sizing: border-box;
          }

          html, body {
            margin: 0;
            padding: 0;
            width: 100%;
            overflow-x: hidden;
          }
          
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
            </style>

            {/* Navigation Bar */}
            <Header
                isMobile={isMobile}
                isSidebarOpen={isSidebarOpen}
                setIsSidebarOpen={setIsSidebarOpen}
                pageTitle={pageTitle}
            />

            {/* Layout Body */}
            <div style={{
                display: 'flex',
                minHeight: '100vh',
                paddingTop: isMobile ? '70px' : '160px',
                boxSizing: 'border-box'
            }}>
                {/* Sidebar */}
                <Sidebar
                    isMobile={isMobile}
                    isSidebarOpen={isSidebarOpen}
                    hoveredItem={hoveredItem}
                    setHoveredItem={setHoveredItem}
                    onNavigate={onNavigate}
                    activePage={activePage}
                    role={role}
                    userInfo={resolvedUserInfo}
                    setIsSidebarOpen={setIsSidebarOpen}
                />

                {/* Main Content */}
                <main style={{
                    flex: 1,
                    marginLeft: isMobile ? '0' : '280px',
                    padding: isMobile ? '1rem' : '2rem',
                    transition: 'all 0.3s ease',
                    boxSizing: 'border-box',
                    width: isMobile ? '100%' : 'calc(100% - 280px)',
                    maxWidth: '100vw',
                    overflowX: 'hidden'
                }}>
                    {children}
                </main>
            </div>

            {/* Backdrop Overlay for mobile view */}
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0, 0, 0, 0.5)',
                    opacity: isSidebarOpen && isMobile ? 1 : 0,
                    visibility: isSidebarOpen && isMobile ? 'visible' : 'hidden',
                    transition: 'all 0.3s ease',
                    zIndex: 1000
                }}
                onClick={() => setIsSidebarOpen(false)}
            />
        </div>
    );
};

export default Layout;
